import { locales } from "./translator.js";
// Lingua del dispositivo al primo accesso (decisione del product owner del 30 settembre 2026): il sistema legge
// la lingua del dispositivo o del browser e imposta quella pertinente fra le supportate; se la persona la cambia
// poi dal profilo, resta la sua scelta. Qui soltanto la lettura dell'header `Accept-Language` (RFC 9110
// §12.5.4): la prima lingua supportata per peso `q`, a parità di peso nell'ordine dell'header. Chi la usa decide
// che cosa vale senza una lingua supportata (per il server, la lingua predefinita dell'azienda).
// Un peso valido: da 0 a 1 con al massimo tre decimali. Senza ripetizioni annidate, quindi lineare.
const QVALUE = /^(?:0(?:\.\d{0,3})?|1(?:\.0{0,3})?)$/;
export function isLocale(value) {
    return typeof value === "string" && locales.includes(value);
}
/** Peso di una voce: 1 senza `q`; `null` se il peso non è valido (la voce si scarta). */
function weightOf(params) {
    let weight = 1;
    for (const param of params) {
        const separator = param.indexOf("=");
        if (separator < 0 || param.slice(0, separator).trim().toLowerCase() !== "q")
            continue;
        const value = param.slice(separator + 1).trim();
        if (!QVALUE.test(value))
            return null;
        weight = Number(value);
    }
    return weight;
}
/**
 * `it`, `it-IT`, `it-CH` → `it`; `en`, `en-GB`, `en-US` → `en`. `q=0` esclude una lingua; `*`, una lingua non
 * supportata o un peso non valido non contano. Nessuna lingua supportata, o nessun header, → `null`.
 */
export function localeFromAcceptLanguage(header) {
    if (!header)
        return null;
    let best = null;
    for (const entry of header.split(",")) {
        const [range = "", ...params] = entry.split(";");
        const primary = range.trim().split("-")[0]?.toLowerCase();
        if (!isLocale(primary))
            continue;
        const weight = weightOf(params);
        if (weight === null || weight === 0)
            continue;
        if (best === null || weight > best.weight)
            best = { locale: primary, weight };
    }
    return best?.locale ?? null;
}
//# sourceMappingURL=accept-language.js.map